import { DATA_HEADERS, DATA_HEADERS_REQUEST } from "../../constants/headers"

const initialState = {
    data: {
        url: '',
        conditionTitle: '',
        title: '',
        onlyTitle: false
    }
}

const headerReducer = (state = initialState, action) => {
    switch (action.type) {
        case DATA_HEADERS_REQUEST:
            return {
                data: {},
                loading: true
            }
        case DATA_HEADERS:
            return {
                ...state,
                loading: false,
                data: action.payload
            }
        default:
            return state
    }
}

export default headerReducer